/* eslint-disable @typescript-eslint/naming-convention */
export const sharedCatalog = {
  resultSort: {
    AlphabeticalAZ: "Alphabetical: A - Z",
    AlphabeticalZA: "Alphabetical: Z - A",
    BestMatch: "Best match",
    LeastExpensive: "Price: Low - High",
    MostExpensive: "Price: High - Low",
    MostPrescribed: "Most prescribed",
  },

  searchTabs: {
    DiscoverBy: "Discover by {{patientTerm}} need",
    Ingredients: "Ingredients",
    Brands: "Brands",
    CommonBrands: "Common brands",
    AllBrands: "All brands",
    CommonIngredients: "Common ingredients",
    AllIngredients: "<0>All</0> ingredients",
    SupplementTypes: "Supplement types",
    Types: "Types",
    options: "{{count}} option",
    options_plural: "{{count}} options",
  },

  landing: {
    PopularProducts: "Popular products",
    RecentlyViewed: "Recently viewed products",
    ProductsYouveExplored: "Products you’ve explored in the last 90 days",
    NoRecentlyViewed: "Looks like you haven't viewed any of our products recently",
  },

  noResults: {
    ClearSearch: "Clear search",
    NoResultsFound: "No results found",
    NoResultsFoundFor: "No results found for:",
    NoResultsForSearch: "It looks like we couldn’t find results for your search.",
    TryClearingSearch: "Try clearing your search or removing some filters.",
    ProductNotFound: "We could not locate that product for you",
    TPDrawerNoResults:
      "Send a {{treatmentPlanTerm}}, and we will show your frequently {{treatmentPlanTermPastParticiple}} products here.",
    NoProductsAdded: "No products added yet",
  },

  filter: {
    Allergens: "Allergens",
    Availability: "Availability",
    Brands: "Brands",
    Certifications: "Certifications",
    Clear: "Clear ({{numberOfFilters}})",
    CommonIngredients: "Common ingredients",
    CurrentOffers: "Current offers",
    CyberMonday: "Cyber Monday",
    CyberMondaySale: "Cyber Monday Sale (-20%)",
    Demographics: "Demographics",
    dosageMax: "Max",
    dosageMin: "Min",
    dosageUnit: "Select units",
    ExcludeIngredients: "Exclude ingredients",
    Favorites: "Favorites",
    Form: "Form",
    HealthConditions: "Health conditions",
    IncludeIngredients: "Include ingredients",
    IngredientToggle: "ingredient exclusivity toggle",
    IngredientToggleText: "Include <1>only</1> these ingredients:",
    InStock: "In stock",
    Only: "Only: <1>{{ingredientName}}</1>",
    OnlyShowFavorites: "Only show favorites",
    PopularBrands: "Popular brands",
    AllBrands: "All brands",
    SearchBrands: "Search for brands",
    SearchIngredients: "Search for ingredients",
    ShowAZ: "Show A-Z",
    ShowProducts_plural: "Show {{count}} products",
    ShowProducts: "Show {{count}} product",
    Sort: "Sort",
    SupplementTypes: "Supplement types",
    seeLess: {
      Allergens: "Hide extra allergen filters",
      Certifications: "Hide extra certification filters",
      Filters: "Hide extra filters",
      Forms: "Hide extra form filters",
      HealthConditions: "Hide extra health condition filters",
    },
    seeMore: {
      Allergens: "Reveal more allergen filters",
      Certifications: "Reveal more certification filters",
      Filters: "Reveal more filters",
      Forms: "Reveal more form filters",
      HealthConditions: "Reveal more health condition filters",
    },
  },

  typeahead: {
    // the groupName translations are evaluated as variables using [ ] in TypeaheadGroup
    groupName: {
      Brand: "Brand",
      Brand_plural: "Brands",
      Product: "Product",
      Product_plural: "Products",
      Ingredient: "Ingredient",
      Ingredient_plural: "Ingredients",
      SupplementType: "Supplement type",
      SupplementType_plural: "Supplement types",
      Condition: "Health condition",
      Condition_plural: "Health conditions",
      SampleType: "Sample type",
      Test: "Test",
      HealthCategory: "Health category",
      Company: "Company",
    },
    ViewAll: "View all",
  },

  excludeSearch: {
    AdvancedSearch: "Advanced search",
    BoxText: "Advanced search. Discover by specific needs.",
    AddIngredient: "Add ingredient",
    ExcludeIngredient: "Exclude ingredient",
    ExcludeInResults: "Exclude in search results:",
    IncludeInResults: "Include in search results:",
    Exclude: "Exclude",
  },

  newOnFullscript: {
    Title: "New on Fullscript",
    Description:
      "We're continuously working directly with suppliers to add the latest products to our catalog.",
  },

  MobileFilterHeader: "Filters",
  CloseFilter: "Close the filter overlay",

  All: "All",
  Popular: "Popular",
  Brands: "Brands",
  brands: "brands",
  Filters: "Filters",
  ClickToScrollUp: "Click to go to top of page",
} as const;
